export default __webpack_public_path__ + "static/media/whiteArrow.f6b9237a.svg";